import { render } from "./loginLayout.vue?vue&type=template&id=5c1fdf0d"
const script = {}

import exportComponent from "E:\\Work\\TEHNOLAND\\megamarketAdmin\\adm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__